style= require('./edit-lineups.styl')
- var moment = require('moment')

if match.season
  .wrapper
    ft-tabs
      each context in contexts
        ft-tab(
          (click)=this.context = context,
          active=this.context === context
        )= context.toUpperCase()
  .wrapper
    .match
      .wrapper
        .blame
          if match && match.lastUpdateBy
            .item
              .key Last updated by:
              .value= match.lastUpdateBy.email
            .item
              .key Last update at:
              .value= moment(match.lastUpdateAt).format('lll')
        .match
          section
            label GW
            = match.round
          sporty-status(match=match)
      .wrapper
        ft-toggle(
          checked=this.pricedOnly,
          (toggle)=this.pricedOnly = !this.pricedOnly
        ) Priced only
        ft-button(
          warning,
          disabled=this.isCopyingPrevious,
          (click)=this.copyPrevious(context)
        ) Auto
        ft-button(
          warning,
          (click)=this.openOverrideModal(match)
        ) Edit Match
        a(href=pricesUrl(match))
          ft-button(warning) Open Prices Page
        ft-button(
          danger,
          (click)=this.fixDuplicates(context)
        ) Fix Duplicates (if any)
        ft-button(
          warning,
          (click)=this.openFormationsModal(match)
        ) Formations

      .match-teams
        if match && match.teams && match.teams.length > 2
          select((change)=this.selectTeam(e.target.value))
            option(value="") <select team>
            option(value="$all-teams", selected=allTeams) <All Teams>
            each team in match.teams
              option(value=team._id selected=this.team === team)= team.name
        .match_teams_info
          -var matchPositions = this.lineupsCountPerTeams(this.match.teams, context)
          .all_teams
            .key All Teams
            .value= matchPositions.total
          .all_teams_positions
            each pos in Object.keys(matchPositions.positions)
              .pos
                .key=pos
                .value= matchPositions.positions[pos].total

      each batch in batches
        if batch
          h3.batch Game #{batch}
        each team in lineupTeams
          - var teamProfile = (this.lineupsCountPerTeams([team], context) || {})
          .wrapper.column
            .team
              .description
                .team_name
                  b= team && team.name
                .team_formations
                  .total
                    | Total
                    b= teamProfile.total
                  each position in Object.keys(teamProfile.positions)
                    .position
                      =position
                      b=teamProfile.positions[position].total
              sporty-team-picker(
                match=match,
                team=team,
                batch=batch,
                context=context,
                priced-only=pricedOnly,
                (select:lineup)=this.addLineup(e),
                (bench:lineup)=this.addLineup(e),
                (unselect:lineup)=this.removeLineup(e)
              )

    if match.isDuel
      .controls
        .wrapper
          each side, $index in ['home', 'away']
            - var team = match[side + 'Team']
            .lineups(class=side)
              b= team && team.name
              each status, index in statuses
                .lineups-count
                  label= status[0].toUpperCase() + status.slice(1)
                  - var val = this.lineupsForStatus(team, status).length
                  - var max = [11,7,11][index]
                  if max
                    .value(class={ready: val === max})= [val, max].join(' / ')
                each lineup in this.lineupsForStatus(team, status)
                  .player
                    .swap((click)=this.swapTeam(lineup)) ⇄
                    if lineup.player.shirt || (lineup.player.shirt === 0)
                      .shirt= lineup.player.shirt + '.'
                    .name= lineup.player.name
                    .position (#{lineup.player.pos})
